import React from 'react';
import { render } from 'react-dom';

import { parseData } from 'join-us/lib/dataLayer';
import { JobBoard } from 'join-us/components/JobBoard';

if (document.getElementById('js-job-board')) {
  global.__greenhouseOfficesCallback = data => {
    // Turning office array into a flattened job array.
    // Not using greenhouse jobs endpoint as the call is too big (500kb gzipped)
    const jobs = parseData(data);

    render(<JobBoard jobs={jobs} />, document.getElementById('js-job-board'));
  };
}
